
export default function EditButton() {
    return (
        <i className="icon edit_icon" />
    )
}